<template>
  <section
    class="pills-container home-categories container-fluid"
    :class="getClass('horizontal-container')"
  >
    <h4 class="text-center" :class="getClass('hidden-xs')">Categorías</h4>
    <ul
      class="list-inline p-none m-none text-center"
      :class="getClass('text-left-xs')"
    >
      <li
        v-for="(category, index) in categories"
        :key="index"
        :data-item="index"
        class="pill m-left-half"
      >
        <a
          class="pill-link"
          @click="selectedCategory(category.name)"
          :title="category.name"
          >{{ category.name }}</a
        >
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "PillsComponent",
  props: {
    categories: {
      type: Array,
      default: () => {
        return {};
      },
    },
    filterMobile: {
      type: Boolean,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    selectedCategory(category) {
      this.$emit("selectedCategory", category);
    },
    getClass(c) {
      if (this.filterMobile === false) {
        return c;
      } else {
        return "";
      }
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.pill-link:hover,
.pill-link:focus {
  color: #ffffff;
  background: #3498db;
  background: -moz-linear-gradient(
    top,
    rgba(52, 152, 219, 0.8) 0%,
    #3498db 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(52, 152, 219, 0.8) 0%,
    gradient 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(52, 152, 219, 0.8) 0%,
    #3498db 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='rgba($gradient,.8)', endColorstr='$gradient',GradientType=0 );
}

.pill-link {
  padding: 10px;
  color: #ffffff;
  border: none;
  border-bottom: 4px solid #217dbb;
  background: #3498db;
  background: -moz-linear-gradient(
    top,
    rgba(52, 152, 219, 0.7) 0%,
    rgba(52, 152, 219, 0.9) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(52, 152, 219, 0.7) 0%,
    rgba(52, 152, 219, 0.9) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(52, 152, 219, 0.7) 0%,
    rgba(52, 152, 219, 0.9) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='rgba($gradient,.7)', endColorstr='rgba($gradient,.9)',GradientType=0 );
  border-radius: 4px;
  letter-spacing: 2px;
  text-transform: uppercase;
}
a:active,
a:focus,
a:hover {
  outline: 0;
  box-shadow: none;
}
.list-inline > li {
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
}
.pills-container ul {
  list-style: none;
  cursor: pointer;
}
h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Open Sans";
  letter-spacing: 2px;
}
.pills-container {
  margin: 10px 0;
  padding: 10px 0;
  line-height: 50px;
  -webkit-overflow-scrolling: touch;
}
@media only screen and (max-width: 747px) {
  .horizontal-container {
    overflow-y: hidden;
    overflow-x: scroll !important;
    margin: 0;
  }
  .horizontal-container ul,
  .horizontal-products-scroller {
    white-space: nowrap !important;
  }
  .text-left-xs {
    text-align: left !important;
  }
  .hidden-xs {
    display: none !important;
  }
  .horizontal-container::-webkit-scrollbar {
    width: 1px !important;
    height: 0 !important;
  }
  .horizontal-container::-webkit-scrollbar-thumb {
    border-radius: 1px !important;
  }
  .horizontal-container::-webkit-scrollbar-track {
    background: 0 0 !important;
    border-radius: 10px !important;
  }
  .horizontal-container {
    overflow-y: hidden;
    overflow-x: scroll !important;
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PillsComponent.vue